
import axios from "../instance/AxiosInstance";
// Base URL for API
const API_BASE = "/promocodes";

// Fetch all promo codes
export const fetchAllPromoCodesEffect = async (payload) => {
  return await axios.get("/promocode/getAllPromocodes", { params: payload });
};
//Create Promo Code
export const createPromoCodeEffect=async(payload)=>{
    return await axios.post("/promocode/createPromocode",payload)
}


// View single promo code
export const viewPromoCodeEffect = async (id) => {
  return await axios.get(`/promocode/getPromocodeById/${id}`);
};

// Update promo code
export const updatePromoCodeEffect = async (payload) => {

  return await axios.put(`/promocode/updatePromocode/${payload.id}`, payload);
};

// Delete promo code
export const deletePromoCodeEffect = async (id) => {
  return await axios.delete(`/promocode/deletePromocode/${id}`);
};

//Approval Status
export const approvalPromoCodeEffect = async (payload) => {

  console.log("payload",payload)
  return await axios.put(`promocode/approvePromocode/${payload.id}`, payload);
};

//Validation
export const validatePromoCodeEffect = async (payload) => {
  return await axios.post("/promocode/promocodevalid", payload);
};


